import { ColDef } from "ag-grid-community";
import {CompletedTime} from "src/app/utility/commonColDef";

export const ThirdPartyAllowlistColumnDefinition: ColDef[] = [
  {
    headerName: "Billing Account Id",
    field: "BillingAccountId",
    resizable: true,
    sortable: true,
  },
  {
    headerName: "Region",
    field: "Region",
    resizable: true,
    sortable: true,
  },
  CompletedTime
];
